<!-- Form -->
<form (ngSubmit)="this.form.submit()" [formGroup]="this.form">

  <div class="row">
    <div class="col-12">
      <app-alert-messages maximumNumberOfMessages="1"></app-alert-messages>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <h2> Contributions salariales </h2>

      <magieno-input-money-field
      [advancedFormControl]="this.form.formElements.employmentIncome | asAdvancedFormControl"></magieno-input-money-field>

      <br>

        <magieno-radio
        [advancedFormControl]="this.form.formElements.incomeFrequencyPeriod | asAdvancedFormControl"></magieno-radio>

        <magieno-select
        [advancedFormControl]="this.form.formElements.fiscalYear | asAdvancedFormControl"></magieno-select>

        <magieno-select
        [advancedFormControl]="this.form.formElements.civilStatus | asAdvancedFormControl"></magieno-select>

        <div>
          <a aria-controls="collapseExample" aria-expanded="false" class="btn btn-link p-0" data-bs-toggle="collapse"
            href="#collapseExample" role="button">
            <span class="me-3">Paramètres avancés</span> <i class="fas fa-chevron-double-down"></i>
          </a>
        </div>
        <div class="collapse" id="collapseExample">
          <div class="card card-body">

            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.shouldQPPBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.shouldQPIPBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.shouldEIBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.shouldCNTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.shouldCNESSTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>

        <div class="mt-4">
          <magieno-button [button]="this.form.getButton('EXECUTE')"
          style="margin-left: 12px"></magieno-button>
        </div>

        <hr>

          @if (this.lifecycleStatus === 'LOADING' || this.lifecycleStatus === 'SENDING') {
            <div>
              <h2>Calcul en cours <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span></h2>
            </div>
          }

          @if (result) {
            <div>
              <h2>Résultats</h2>
              <h4 class="mt-3">Cotisations de l'employé</h4>
              <table class="table table-responsive" style="font-size: 0.85rem;">
                <thead>
                  <tr>
                    <th>Cotisation</th>
                    <th style="width: 150px;">Montant ($)</th>
                    <th style="width: 125px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <!--                    <tr>-->
                  <!--                        <td>Impôt provincial</td>-->
                  <!--                        <td class="text-end"></td>-->
                  <!--                        <td></td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>Impôt fédéral</td>-->
                <!--                        <td class="text-end"></td>-->
                <!--                        <td></td>-->
              <!--                    </tr>-->
              <!--                    <tr>-->
              <!--                        <td></td>-->
              <!--                        <td class="text-end"><strong>Sous-total:</strong></td>-->
              <!--                        <td class="text-end"><strong></strong></td>-->
            <!--                    </tr>-->
            <tr>
              <td>Assurance Emploi</td>
              <td class="text-end">{{ this.result.results.employeeContributions.EI | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Régime des rentes du Québec (RRQ)</td>
              <td class="text-end">{{ this.result.results.employeeContributions.QPP | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Régime québécois d'assurance parentale (RQAP)</td>
              <td class="text-end">{{ this.result.results.employeeContributions.QPIP | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-end"><strong>Sous-total:</strong></td>
              <td class="text-end"><strong> {{ employeeContributionsSubtotal() | currencyCents }}</strong></td>
            </tr>
            <tr class="table-active">
              <td class=""></td>
              <td class="text-end"><strong>Total:</strong></td>
              <td class="text-end"><strong>{{ employeeContributionsTotal() | currencyCents }}</strong></td>
            </tr>
          </tbody>
        </table>
        <h4 class="mt-3">Cotisations de l'employeur</h4>
        <table class="table table-responsive" style="font-size: 0.85rem;">
          <thead>
            <tr>
              <th>Cotisation</th>
              <th style="width: 150px;">Montant ($)</th>
              <th style="width: 125px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Assurance Emploi</td>
              <td class="text-end">{{ this.result.results.employerContributions.EI | currencyCents }}</td>
              <!--                        <td class="text-end">{{ result.results. schedule10.eIEmployerContributions | currency }}</td>-->
              <td></td>
            </tr>
            <tr>
              <td>Régime des rentes du Québec (RRQ)</td>
              <td class="text-end">{{ this.result.results.employerContributions.QPP | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Régime québécois d'assurance parentale (RQAP)</td>
              <td class="text-end">{{ this.result.results.employerContributions.QPIP | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Cotisation au fonds des services santé</td>
              <td class="text-end">{{ this.result.results.employerContributions.FSS | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>CNESST</td>
              <td class="text-end">{{ this.result.results.employerContributions.CNESST | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-end"><strong>Sous-total:</strong></td>
              <td class="text-end"><strong> {{ employerContributionsSubtotal() | currencyCents }}</strong></td>
            </tr>
            <tr>
              <td>CNT (0.06%)</td>
              <td class="text-end">{{ this.result.results.employerContributions.CNT | currencyCents }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Vacances (4%)</td>
              <td class="text-end"></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-end"><strong>Sous-total:</strong></td>
              <td class="text-end"><strong>{{ this.result.results.employerContributions.CNT | currencyCents }}</strong>
            </td>
          </tr>
          <tr class="table-active">
            <td class=""></td>
            <td class="text-end"><strong>Total:</strong></td>
            <td class="text-end"><strong>{{ employerContributionsTotal() | currencyCents }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  <!--            <pre>-->
  <!--                {{ this.form.value | json }}-->
<!--            </pre>-->

<!--            <magieno-input-number-field-->
<!--                    [advancedFormControl]="this.form.formElements.numberOfPayPeriodsInTheYear | asAdvancedFormControl"></magieno-input-number-field>-->

<!--            <magieno-input-number-field units="$"-->
<!--                                    [advancedFormControl]="this.form.formElements.employeesQPPContributionsWithheld | asAdvancedFormControl"></magieno-input-number-field>-->

<!--            <magieno-select-->
<!--                    [advancedFormControl]="this.form.formElements.year | asAdvancedFormControl"></magieno-select>-->
</div>
</div> <!-- / .row -->
</form>